<template>
    <div class="tiaoman" id="tm">
        <div class="tiaoman-box" id="tm_box">
            <img src="../static/tm1.jpg" class="tm" alt="">
            <img src="../static/tm2.jpg" class="tm" alt="">
            <img src="../static/tm3.jpg" class="tm" alt="">
            <img src="../static/tm4.jpg" class="tm" alt="">
            <img src="../static/tm5.jpg" class="tm" alt="">
            <img src="../static/tm6.jpg" class="tm" alt="">
            <img src="../static/tm7.jpg" class="tm" alt="">
        </div>
        <img src="../static/go.png" class="go" v-show="!iftobuttom" @click="tobottom" alt="">
         <img src="../static/stop.png" class="go" v-show="iftobuttom"  @click="tobottom" alt="">
        <audio id="audio" loop="loop" :src="require('@/static/bgm.mp3')"></audio>
    </div>
</template>

<script>
export default {
    data() {
        return {
            timer: null,
            iftobuttom: false,
        }
    },
    methods: {
        tobottom() {
            var home = document.getElementById("tm");
            var homebg = document.getElementById("tm_box");
            var scrollDistance = 1.5;
            var height = homebg.offsetHeight;
            var screenHeight = window.innerHeight;

             const video = document.getElementById("audio")
              video.play();
            // console.log('相差：', height - screenHeight);

            // console.log('高', height);
            // console.log('屏幕：', screenHeight);
            // console.log('滚轮高度:', home.scrollTop);
            if (!this.iftobuttom) {
                this.iftobuttom=true
                  var element = document.getElementById("tm");
                 element.addEventListener("scroll", this.thescroll,)
                this.timer = setInterval(() => {

                    home.scrollTop = home.scrollTop + scrollDistance
                    // console.log( home.scrollTop);
                    
                    if (home.scrollTop >= height - screenHeight - 1) {
                         this.iftobuttom=false
                        console.log("到底了");
                        clearTimeout(this.timer);
                       

                    }
                }, 15)
            }else{
                clearTimeout(this.timer);
                this.iftobuttom=false
            }



        },
        thescroll() {
            // console.log(3333,document.getElementById("tm").scrollTop);
            
            // 滚动条距文档顶部的距离
            let scrollTop =
               
                document.getElementById("tm").scrollTop ||
                document.body.scrollTop;
            //滚动条滚动的距离
            // let scrollStep = scrollTop - this.oldScrollTop;
            // console.log("header 滚动距离 ", scrollTop);

            // 更新——滚动前，滚动条距文档顶部的距离
            // this.oldScrollTop = scrollTop;

            //变量windowHeight是可视区的高度
            let windowHeight =
                document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            let scrollHeight =
                document.getElementById("tm_box").scrollHeight || document.body.scrollHeight;

            // console.log(66,scrollTop,scrollHeight,windowHeight);

            //滚动条到底部的条件
            if (scrollTop + windowHeight >= scrollHeight - 2) {
                //你想做的事情
                console.log("header  你已经到底部了");


            }
            //   if (scrollStep < 0) {
            //     console.log("header 滚动条向上滚动了！");
            //   } else {
            //     console.log("header  滚动条向下滚动了！");
            //   }
            // 判断是否到了最顶部

            let bl = window.innerWidth / 375
            const video = document.getElementById("audio")
            if (scrollTop > 12200 * bl) {
                if (video.paused) {
                    video.play();
                }

            }

            if (scrollTop <= 0) {
                console.log("header 到了最顶部")
            }
        },
    },
    mounted() {
      
        document.title='条漫|战火中的娃娃兵'
 
        
    },
}

</script>

<style lang="less" scoped>
.tiaoman {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    overflow-y: auto;

    .go {
        position: fixed;
        bottom: 0px;
        
        width: 375px;
        z-index: 3;
    }

    .tiaoman-box {
        position: relative;
        width: 100%;

        .tm {
            width: 100%;
            display: block;
        }
    }

}
</style>
